const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Fai la tua scelta qui.",
  seeAll: "Vedi tutto",
  clear: "Cancella",
  back: "Indietro",
  save: "Salva",
  close: "Chiudi",
  of: "Di",
  to: "A",
  copyrights: "© {date} Bridgestone Solutions. Tutti i diritti riservati.",
  pageNotFound: "Pagina non trovata",
  accessDenied: "Accesso negato",
  search: "Cerca",
  year: "Anno",
  buttons: {
    loading: "Caricamento...",
    export: "Esporta",
    delete: "Elimina",
    save: "Salva",
    cancel: "Annulla",
    next: "Avanti",
    back: "Indietro",
    clear: "Cancella",
    skip: "Salta",
    send: "Invia",
    readNow: "Leggi ora",
    pointsList: "Elenco dei punti",
    more: "Di più",
    close: "Chiudi",
    reportError: "Segnala errori",
    accept: "Accetta",
    download: "Scarica",
    downloadAll: "Scarica tutto",
    selectAll: "Seleziona tutto",
    deselectAll: "Deseleziona tutto",
    downloadSelection: "Scarica selezione",
    dealerInfoDownload: "Scarica",
    toTheBasket: "Nel carrello",
    toOrderDelivery: "Continua all'indirizzo di consegna",
    discover: "Scoprire",
    newAddress: "Crea un nuovo indirizzo di consegna",
    selectAddressBtn: "Seleziona indirizzo di consegna",
    toOrderSummary: "Vai al riepilogo ordine",
    placeOrder: "Ordina con obbligo d'acquisto",
    toDashboard: "Vai alla homepage",
    newOrder: "Nuovo ordine",
    userOrders: "Vai ai tuoi ordini",
    toSearch: "Cerca",
    select: "Seleziona",
    moreCustomerNumbers: "+ AGGIUNGI ALTRI NUMERI CLIENTE",
    loadMore: "Carica altri",
    toStaffDashboard: "Vai al dashboard",
    toQuiz: "Vai al quiz",
    vouchers: "Buoni",
    exchangeVoucher: "Riscatta codice voucher",
    confirm: "Conferma",
    sharePoints: "Condividi punti",
    create: "Crea",
    update: "Aggiorna",
    toBDrive: "PER B-DRIVE",
    preview: "Anteprima",
    toDiscover: "Scoprire",
    makeContact: "Contattateci",
    clickHere: "Vedi i dettagli",
    setFilters: "Imposta <b>al massimo un filtro per colonna</b>",
    all: "Tutti",
  },
  tooltips: {
    info: "Hai bisogno di aiuto?",
  },
  confirmation: {
    header: "Conferma richiesta",
    message: "Vuoi eliminare questa voce?",
  },
  nav: {
    consents: "Consensi",
    dashboard: "Home",
    accountDashboard: "Home",
    account: "Il mio profilo",
    mailbox: "Posta in arrivo",
    singleMailbox: "Messaggi",
    stammdaten: "Anagrafica",
    news_feeds: "Notizia",
    pointsOverview: "Panoramica punti",
    rewardsOverview: "Panoramica punti",
    about: "Informazioni su BS Plus",
    service_number: "Contatti",
    shop: "Negozio a premi",
    salesPromotions: "Promozioni di vendita",
    promotions: "Il mio account",
    shopCategory: "Negozio premi",
    productDetails: "Dettagli prodotto",
    userOrders: "Ordini utente",
    shoppingCart: "Carrello",
    orderDelivery: "Indirizzo di consegna",
    orderSummary: "Riepilogo ordine",
    orderComplete: "Ordine completato",
    text_page: "Pagina statica",
    staff: "Dashboard servizi",
    onlineTrainings: "Formazioni online",
    trainings: "Formazioni",
    training: "Formazione",
    trainingForm: "Modulo formazione",
    staffVouchers: "Voucher",
    wholesalerVouchers: "Voucher",
    brochure_prices: "Listini e brochure",
    investment: "Sostegno agli investimenti",
    media: "Media",
    medias: "Media",
    contact_service: "Informazioni di contatto e servizio",
    productInfo: "Informazioni sul prodotto",
    preislisten: "Listini prezzi",
    preislistenList: "Listini prezzi",
    pricat: "Prezzo",
    bDrive: "Immagini dei prodotti",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Condizioni di partecipazione",
    first_stop: "Garanzia pneumatici Bridgestone",
    payouts: "Payouts",
  },
  breadcrumbs: {
    dashboard: "Home",
    accountDashboard: "Home",
    account: "Il mio profilo",
    mailbox: "Posta in arrivo",
    singleMailbox: "Messaggi",
    stammdaten: "Anagrafica",
    news_feeds: "Notizia",
    pointsOverview: "Panoramica punti",
    rewardsOverview: "Panoramica punti",
    about: "Informazioni su BS Plus",
    service_number: "Contatti",
    shop: "Negozio a premi",
    salesPromotions: "Promozioni di vendita",
    promotions: "Il mio account",
    shopCategory: "Negozio premi",
    productDetails: "Dettagli prodotto",
    userOrders: "Ordini utente",
    shoppingCart: "Carrello",
    orderDelivery: "Indirizzo di consegna",
    orderSummary: "Riepilogo ordine",
    orderComplete: "Ordine completato",
    staff: "Dashboard servizi",
    onlineTrainings: "Formazioni online",
    trainings: "Formazioni",
    training: "Formazione",
    trainingForm: "Modulo formazione",
    staffVouchers: "Voucher",
    wholesalerVouchers: "Voucher",
    brochure_prices: "Listini e brochure",
    investment: "Sostegno agli investimenti",
    media: "Media",
    medias: "Media",
    contact_service: "Informazioni di contatto e servizio",
    productInfo: "Informazioni sul prodotto",
    preislisten: "Listini prezzi",
    preislistenList: "Listini prezzi",
    pricat: "Prezzo",
    bDrive: "Immagini dei prodotti",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Condizioni di partecipazione",
    first_stop: "Garanzia pneumatici Bridgestone",
    payouts: "Payouts",
  },
  menu: {
    account: "Il mio profilo",
    plus: 'Informazioni su Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Supporto alle vendite",
    mailbox: "Posta in arrivo",
    about: "Informazioni su BS Plus",
    trainingAndCourses: "Formazione e corsi",
    externalTraining: "Formazione esterna",
    productInfo: "Informazioni sul prodotto",
    productBrochures: "Brochure dei prodotti",
    priceLists: "Listini prezzi",
    price: "Prezzo",
    complaintForm: "Modulo di reclamo",
    sales_support: "Supporto alle vendite",
    contact_service: "Informazioni di contatto e servizio",
    logOut: "Disconnetti",
    news: "Notizie",
    news_feeds: "Notizia",
    service_number: "Contatti",
    salesPromotions: "Promozioni di vendita",
    shop: "Negozio di premi",
    onlineTrainings: "Formazioni online",
    trainings: "Formazioni",
    brochure_prices: "Listini e brochure",
    media: "Media",
    medias: "Media",
    preislisten: "Listini prezzi",
    stammdaten: "Anagrafica",
  },
  validation: {
    requiredField: "Campo obbligatorio",
  },
  sortBy: {
    default: "Ordina per",
    desc: "Ordina per: più recenti",
    asc: "Ordina per: meno recenti",
    name: "Nome",
    date: "Data",
    choiceBy: "Ordina",
  },
  month: {
    1: "gennaio",
    2: "febbraio",
    3: "marzo",
    4: "aprile",
    5: "maggio",
    6: "giugno",
    7: "luglio",
    8: "agosto",
    9: "settembre",
    10: "ottobre",
    11: "novembre",
    12: "dicembre",
  },
};

export default {
  messages,
};
